<template>
  <div>
    <div class="row g-3">
      <div
        v-for="group in mappedGroups"
        :key="group.id"
        class="col-12 col-md-6 col-lg-3 rounded-5"
      >
        <GroupCard v-bind="group" />
      </div>
    </div>
    <div class="mb-4"></div>
    <ButtonGroup
      :filters="buttonFilters"
      groupName="timeFiltersGroup"
      @setSelectedFilter="setSelectedTimeFilter($event)"
    />
  </div>
</template>

<script>
import { TIME_FILTERS } from "@/data/enums.js";
import { mappedFilters } from "@/helpers/common.js";
import { mapGetters } from "vuex";

import GroupCard from "@/components/activity/GroupCard.vue";
import ButtonGroup from "@/components/activity/ButtonGroup.vue";

// Data
export default {
  name: "GroupsScoreboard",
  components: { GroupCard, ButtonGroup },
  data: function () {
    return {
      selectedTimeFilter: mappedFilters(TIME_FILTERS)[0].id
    };
  },
  computed: {
    ...mapGetters("groups", ["getMappedGroups"]),
    buttonFilters() {
      let filters = mappedFilters(TIME_FILTERS);

      return filters;
    },

    mappedGroups() {
      let groups = [...this.getMappedGroups];

      groups.forEach((group) => {
        group.points =
          this.selectedTimeFilter === TIME_FILTERS.WEEKLY
            ? group.pointsWeekly
            : group.pointsAllTime;
      });

      let highestPoints = Math.max(...groups.map((group) => group.points));

      groups = groups.map((group) => {
        group.isTopGroup = group.points === highestPoints && highestPoints > 0;
        return group;
      });

      return groups;
    }
  },
  methods: {
    setSelectedTimeFilter(filter) {
      this.selectedTimeFilter = filter;
    }
  }
};
</script>
